import { Council, Board } from 'types';
import { StatusCount } from '../types/StatusCount';
import { statusTypes } from '../constants/statusTypes';

export const getStatusCountByBoards = (boards: Council[] | Board[]) => {
  const boardsByStatus: StatusCount = {
    preparing: 0,
    active: 0,
    signPending: 0,
    closed: 0,
    canceled: 0,
  };

  boards.forEach((board) => {
    switch (board.status) {
      case statusTypes.PENDING:
        boardsByStatus.preparing += 1;
        break;
      case statusTypes.ACTIVE:
        boardsByStatus.active += 1;
        break;
      case statusTypes.SIGNATURE_PENDING:
        boardsByStatus.signPending += 1;
        break;
      case statusTypes.CLOSED:
        boardsByStatus.closed += 1;
        break;
      case statusTypes.CANCELED:
        boardsByStatus.canceled += 1;
        break;

      default:
        break;
    }
  });

  return boardsByStatus;
};
